angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "NUMBER_OF_PEOPLE": {
    "1": "Just me",
    "2": "Two people",
    "3": "Three people",
    "4": "More than three"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/constants/number_of_people.json
// module id = 123
// module chunks = 24